import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { StopwatchJson } from '@core/models/built/session-step-value-json.model';
import { SessionStep, SessionStepValue } from '@core/models/session.model';
import { TranslocoService } from '@ngneat/transloco';
import { DateTime, Duration } from 'luxon';
import { BehaviorSubject } from 'rxjs';
import { first, map } from 'rxjs/operators';

import it from './i18n/input-stopwatch-report.it.json';

@Component({
  templateUrl: './input-stopwatch-report.component.html',
  styleUrls: ['./input-stopwatch-report.component.scss']
})
export class InputStopwatchReportComponent implements OnChanges {

  @Input() step!: SessionStep;

  private step$$ = new BehaviorSubject<SessionStep>(this.step);
  step$ = this.step$$.asObservable();

  values$ = this.step$.pipe(
    map(step => this.orderValuesByTimestampAsc(step.values || [])),
    first()
  );

  totalDuration$ = this.values$.pipe(
    map(values => {
      const last = values.pop();
      const ms = last ? (last.value as StopwatchJson).durationFromStepStart : 0;
      const hh = Math.floor(Duration.fromMillis(ms).as('hours')).toString().padStart(2, '0');
      const mm = Math.floor(Duration.fromMillis(ms).as('minutes') % 60).toString().padStart(2, '0');
      const ss = Math.floor(Duration.fromMillis(ms).as('seconds') % 60).toString().padStart(2, '0');
      return `${hh}:${mm}:${ss}`;
    }),
  );

  constructor(
    private translocoSvc: TranslocoService
  ) {
    this.translocoSvc.setTranslation(it, 'it');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.step) {
      this.step$$.next(changes.step.currentValue);
    }
  }

  private orderValuesByTimestampAsc(values: SessionStepValue[]): SessionStepValue[] {
    const ordered = [...values].sort((a, b) => {
      if (DateTime.fromJSDate(new Date(a.timestamp)) < DateTime.fromJSDate(new Date(b.timestamp))) {
        return -1;
      }
      if (DateTime.fromJSDate(new Date(a.timestamp)) > DateTime.fromJSDate(new Date(b.timestamp))) {
        return 1;
      }
      return 0;
    }) || [];
    return ordered;
  }

}
